(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';

function _mapBloodPressure(observation) {
  var systolicBloodPressure = null;
  var diastolicBloodPressure = null;
  var component = observation.component;
  component.forEach(function (componentItem) {
    var componentCode = componentItem.code,
        valueQuantity = componentItem.valueQuantity;

    var _ref = componentCode || {},
        coding = _ref.coding;

    var _ref2 = coding && !!coding.length && coding[0] || {},
        code = _ref2.code,
        system = _ref2.system;

    var _ref3 = valueQuantity || {},
        value = _ref3.value,
        unit = _ref3.unit;

    if (!code || !system || !value || !unit) {
      return;
    }

    if (system === 'http://loinc.org' && code === '8480-6') {
      systolicBloodPressure = "".concat(value, " ").concat(unit);
    } else if (system === 'http://loinc.org' && code === '8462-4') {
      diastolicBloodPressure = "".concat(value, " ").concat(unit);
    }
  });

  if (!systolicBloodPressure || !diastolicBloodPressure) {
    return {};
  }

  return {
    systolicBloodPressure: systolicBloodPressure,
    diastolicBloodPressure: diastolicBloodPressure
  };
}

function _mapHeartRate(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref4 = valueQuantity || {},
      value = _ref4.value,
      unit = _ref4.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    heartRate: "".concat(value, " ").concat(unit)
  };
}

function _mapOxygenSaturation(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref5 = valueQuantity || {},
      value = _ref5.value,
      unit = _ref5.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    oxygenSaturation: "".concat(value, " ").concat(unit)
  };
}

function _mapBodyTemperature(observation) {
  var valueQuantity = observation.valueQuantity;

  var _ref6 = valueQuantity || {},
      value = _ref6.value,
      unit = _ref6.unit;

  if (!value || !unit) {
    return {};
  }

  return {
    bodyTemperature: "".concat(value, " ").concat(unit)
  };
}

function _mapObservations(observations, panelObservation) {
  var vitalsData = {};
  observations.forEach(function (observation) {
    var _ref7 = observation && observation.code || {},
        coding = _ref7.coding;

    var _ref8 = coding && !!coding.length && coding[0] || {},
        code = _ref8.code,
        system = _ref8.system;

    if (!code || !system) {
      return;
    }

    if (!observation.effectiveDateTime) {
      return;
    }

    vitalsData.idMap = vitalsData.idMap || {};
    vitalsData.date = vitalsData.date || moment(observation.effectiveDateTime).local().format("ddd, MMM D, YYYY, HH:mm"); // Blood Pressure

    if (system === 'http://loinc.org' && code === '85354-9') {
      vitalsData.idMap.bloodPressure = observation.id;
      vitalsData = Object.assign({}, vitalsData, _mapBloodPressure(observation));
    } // Heart Rate


    if (system === 'http://loinc.org' && code === '8867-4') {
      vitalsData.idMap.heartRate = observation.id;
      vitalsData = Object.assign({}, vitalsData, _mapHeartRate(observation));
    } // Oxygen Saturation


    if (system === 'http://loinc.org' && code === '2708-6') {
      vitalsData.idMap.oxygenSaturation = observation.id;
      vitalsData = Object.assign({}, vitalsData, _mapOxygenSaturation(observation));
    } // Body Temperature


    if (system === 'http://loinc.org' && code === '8310-5') {
      vitalsData.idMap.bodyTemperature = observation.id;
      vitalsData = Object.assign({}, vitalsData, _mapBodyTemperature(observation));
    } // Set Vitals Panel id if it belongs to one


    if (panelObservation && panelObservation.hasMember && panelObservation.hasMember.some(function (hm) {
      return hm.reference === "Observation/".concat(observation.id);
    })) {
      vitalsData.idMap.panel = panelObservation.id;
    }
  });

  if (!Object.keys(vitalsData).length) {
    return null;
  }

  return vitalsData;
}

export default function mapFromFHIR(observationBundleEntry) {
  // Group observations by effectiveDateTime
  var observationsByDateTime = observationBundleEntry.reduce(function (acc, obs) {
    var _ref9 = obs || {},
        resource = _ref9.resource;

    var _ref10 = resource || {},
        effectiveDateTime = _ref10.effectiveDateTime;

    if (!effectiveDateTime) {
      return acc;
    }

    acc[effectiveDateTime] = acc[effectiveDateTime] || [];
    acc[effectiveDateTime].push(resource);
    return acc;
  }, {});
  var vitalsDataList = []; // Find vitals panel and add its id into each vitals data

  Object.values(observationsByDateTime).forEach(function (observations) {
    // Get vitals panels
    var vitalsPanelObservations = observations.filter(function (obs) {
      var _ref11 = obs && obs.code || {},
          coding = _ref11.coding;

      var _ref12 = coding && !!coding.length && coding[0] || {},
          code = _ref12.code,
          system = _ref12.system; // Vital signs, weight, height, head circumference, oxygen saturation and BMI panel


      return system === 'http://loinc.org' && code === '85353-1';
    });

    if (vitalsPanelObservations && vitalsPanelObservations.length) {
      // Get individual vitals from vitals panel
      vitalsPanelObservations.forEach(function (vitalsPanelObservation) {
        var vitalsObservations = observations.filter(function (obs) {
          return !vitalsPanelObservation || vitalsPanelObservation.hasMember.some(function (hm) {
            return hm.reference === "Observation/".concat(obs.id);
          });
        });

        var vitalsData = _mapObservations(vitalsObservations, vitalsPanelObservation);

        if (!vitalsData) {
          return;
        }

        vitalsDataList.push(vitalsData);
      });
    } else {
      // Get individual vitals directly since there is no panel
      var vitalsData = _mapObservations(observations, null);

      if (!vitalsData) {
        return;
      }

      vitalsDataList.push(vitalsData);
    }
  });
  return vitalsDataList;
}
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_mapBloodPressure, "_mapBloodPressure", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapHeartRate, "_mapHeartRate", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapOxygenSaturation, "_mapOxygenSaturation", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapBodyTemperature, "_mapBodyTemperature", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(_mapObservations, "_mapObservations", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapFromFHIR.js");
  reactHotLoader.register(mapFromFHIR, "mapFromFHIR", "/home/runner/html/nextcloud/apps/ehr/js/plugins/vitals/src/mappers/mapFromFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();